export function removeTextMask(value?: string) {
  return !!value ? value.replace(/[^0-9A-Za-zÀ-üÇç]/g, '') : value;
}
